<template>
    <div>
        <ReferralInformationSection />
        <PreadmissionNotes class="mt-2" />
    </div>
</template>

<script src="./ReferralInformation.ts"></script>
